class ParametrosTributarios {
    static get $inject() {
        return ['gql']
    }

    constructor(gql) {
        this.gql = gql
    }

    createFilialIcms(empresaId, filialId, params) {
        const mutation = gql`
            mutation CreateFilialIcms($empresaId: String!, $filialId: String! $params: FilialIcmsParams!) {
                empresa(id: $empresaId) {
                    icms: createFilialIcms(filialId: $filialId, params: $params) {
                        id
                        regimeTributario { 
                            id
                            nome
                        }
                        atividades { 
                            id
                            descricao
                        }
                        aplicacoes { 
                            id
                            nome
                        }
                        perfis {
                            configuracoes {
                                cnpjFornecedores
                                numeroTermo
                            }
                            perfil { 
                                id
                                nome
                            }
                        }
                        vigencia {
                            from
                            to
                        }
                    }
                }
            }
        `
        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), filialId: filialId.toString(), params })
            .then(({ empresa }) => empresa.icms)
    }

    updateFilialIcms(empresaId, icms) {
        const mutation = gql`
            mutation UpdateFilialIcms($empresaId: String!, $icmsId: Int!, $params: FilialIcmsParams!) {
                empresa(id: $empresaId) {
                    icms: updateFilialIcms(icmsId: $icmsId, params: $params) {
                        id
                        regimeTributario { 
                            id
                            nome
                        }
                        atividades { 
                            id
                            descricao
                        }
                        aplicacoes { 
                            id
                            nome
                        }
                        perfis {
                            configuracoes {
                                cnpjFornecedores
                                numeroTermo
                            }
                            perfil { 
                                id
                                nome
                            }
                        }
                        vigencia {
                            from
                            to
                        }
                    }
                }   
            }
        `
        const { id: icmsId, ...params } = icms

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), icmsId, params })
            .then(({ empresa }) => empresa.icms)
    }

    deleteFilialIcms(empresaId, { id: icmsId }) {
        const mutation = gql`
            mutation DeleteFilialIcms($empresaId: String!, $icmsId: String!) {
                empresa(id: $empresaId) {
                    icms: deleteFilialIcms(icmsId: $icmsId) {
                        id
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), icmsId })
            .then(({ empresa }) => empresa.icms)
    }

    createFilialPisCofins(empresaId, { id: filialId }, params) {
        const mutation = gql`
            mutation CreateFilialPisCofins($empresaId: String!, $filialId: Int!, $params: FilialPisCofinsParams!) {
                empresa(id: $empresaId) {
                    pisCofins: createFilialPisCofins(filialId: $filialId, params: $params) {
                        id
                        aliquotaPis
                        aliquotaCofins
                        atividade
                        regimeTributario {
                            id
                            nome
                        }
                        vigencia {
                            from
                            to
                        }
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), filialId, params })
            .then(({ empresa }) => empresa.pisCofins)
    }

    updateFilialPisCofins(empresaId, { id: pisCofinsId, ...params }) {
        const mutation = gql`
            mutation UpdateFilialPisCofins($empresaId: String!, $pisCofinsId: Int!, $params: FilialPisCofinsParams!) {
                empresa(id: $empresaId) {
                    pisCofins: updateFilialPisCofins(pisCofinsId: $pisCofinsId, params: $params) {
                        id
                        aliquotaPis
                        aliquotaCofins
                        atividade
                        regimeTributario {
                            id
                            nome
                        }
                        vigencia {
                            from
                            to
                        }
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), pisCofinsId, params })
            .then(({ empresa }) => empresa.pisCofins)
    }

    deleteFilialPisCofins(empresaId, { id: pisCofinsId }) {
        const mutation = gql`
            mutation DeleteFilialPisCofins($empresaId: String!, $pisCofinsId: String!) {
                empresa(id: $empresaId) {
                    pisCofins: deleteFilialPisCofins(pisCofinsId: $pisCofinsId) {
                        id
                    }
                }
            }
        `

        return this.gql
            .mutate(mutation, { empresaId: empresaId.toString(), pisCofinsId })
            .then(({ empresa }) => empresa.pisCofins)
    }

    isOverlap(vigencia, vigencia2) {
        vigencia = {
            from: vigencia.from ? new Date(vigencia.from) : -Infinity,
            to: vigencia.to ? new Date(vigencia.to) : Infinity
        }

        vigencia2 = {
            from: vigencia2.from ? new Date(vigencia2.from) : -Infinity,
            to: vigencia2.to ? new Date(vigencia2.to) : Infinity
        }

        return (vigencia.from <= vigencia2.to) && (vigencia.to >= vigencia2.from)
    }

    async getGaps(params) {
        const lazyMoment = await import(/* webpackChunkName: "moment" */ 'moment')
        const moment = lazyMoment.default

        const { gaps, date } = [...params]
            .sort((p1, p2) => this.sortVigencia(p1.vigencia, p2.vigencia))
            .reverse()
            .reduce(({ date, gaps }, { vigencia }) => {
                if (date == 'initial' && vigencia.from) {
                    return {
                        date: vigencia.to,
                        gaps: [...gaps, { from: null, to: vigencia.from }]
                    }
                }

                const lastDate = new moment(date)
                const vigenciaFrom = new moment(vigencia.from)

                if (vigenciaFrom.diff(lastDate, 'days') > 1) {
                    return {
                        date: vigencia.to,
                        gaps: [...gaps, { from: date, to: vigencia.from }]
                    }
                }

                return { date: vigencia.to, gaps }

            }, { date: 'initial', gaps: [] })

        if (date && date != 'initial') {
            gaps.push({ from: date, to: null })
        }

        return gaps.map(({ from, to }) => {
            return {
                from: from && new moment(from).add(1, 'days').format('YYYY-MM-DD'),
                to: to && new moment(to).subtract(1, 'days').format('YYYY-MM-DD')
            }
        })
    }

    sortVigencia(vigencia, vigencia2) {
        return !vigencia.from || vigencia.from < vigencia2.from ? 1 : -1
    }

    isVigente({ from, to }) {
        return (!from || new moment(from).isSameOrBefore(new Date(), 'days'))
            && (!to || new moment(to).isSameOrAfter(new Date(), 'days'))
    }

    getPisCofinsVigente(empresa) {
        const query = gql`
            query PisCofinsVigente {
                empresa: filial(id: ${empresa.id}) {
                    id
                    pisCofinsVigente {
                        id
                        aliquotaPis
                        aliquotaCofins
                        atividade
                        regimeTributario {
                            id
                            nome
                        }
                        vigencia {
                            from
                            to
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query)
            .then(({ empresa }) => empresa.pisCofinsVigente)
    }

    getIcmsVigente(empresa) {
        const query = gql`
            query PisCofinsVigente {
                empresa: filial(id: ${empresa.id}) {
                    id
                    icmsVigente {
                        id
                        regimeTributario { 
                            id
                            nome
                        }
                        atividades { 
                            id
                            descricao
                        }
                        aplicacoes { 
                            id
                            nome
                        }
                        perfis {
                            configuracoes {
                                cnpjFornecedores
                                numeroTermo
                            }
                            perfil { 
                                id
                                nome
                            }
                        }
                        vigencia {
                            from
                            to
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query)
            .then(({ empresa }) => empresa.icmsVigente)
    }
}

angular.module("eficienciaFiscalModule").service("ParametrosTributarios", ParametrosTributarios)
